import styledCmp from 'styled-components'

import { styled } from '@mui/material/styles';

import Switch from '@mui/material/Switch';

export const MaterialSwitch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: theme.palette.blue.contrastText,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.palette.blue.main,
        opacity: 1,
    },
    '& .MuiSwitch-track': {
        backgroundColor: theme.palette.colors.borderStrong,
        opacity: 1,
    },
}));


export const SideItemText = styledCmp.div.attrs({
})`    
    font-family: Gilroy-Regular;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    color: ${props => props.active ? props.theme.palette.colors.white : props.theme.palette.colors.text};
    transition: 0.3s;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    line-height: 1.2;
`;
